export default __webpack_public_path__ + "static/media/male-front.2e64834a.png";